import React from "react";

const url = "https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png";

const PayPalLogo = () => {
    return <img src={ url } alt="PayPal Logo" />;
};

export default PayPalLogo;
